import React from 'react';

export default (props) => {
  // const src = `https://app.sli.do/event/j1z0tkm9?user_name=${props.firstname}%20${props.surname}&user_email=${props.email}&user_company=${props.company}`
  let src = `https://app.sli.do/event/${props.eventCode}`;
  if (props.firstname && props.surname) { 
    src = `https://app.sli.do/event/${props.eventCode}?user_name=${props.firstname}%20${props.surname}`
  }
  return (
    <iframe src={src} height="100%" width="100%" style={{ backgroundColor: '#fff', border: 'none', minHeight: '560px'}} title="Group Chat"></iframe>
  );
}
